import React, { FC } from "react";
import { classNames } from "helpers/themeHelpers";
import { useTheme } from "styled-components";
import IconCheckCircled from "assets/IconCheckCircled";
import { linkToOpenShop } from "helpers/links-builders/openshopLink";
import Image from "componentReusable/Image";
import { useSsoContext } from "contexts/authSSOContext";
import { gtmOpenShopBtnWidgetSeller } from "GTMs/actions/commonActions";
import { EnumWidgets } from "../../libs/logging/types/loggingTypes";
import { upgradeAccountClick } from "../../libs/logging/helpers/loggingActions";

interface IProps {
  isSameLine?: boolean;
  isPostView?: boolean;
  isShop?: boolean;
  member_id?: string | number;
  widgetName?: EnumWidgets;
}

const WidgetGetMoreListing: FC<IProps> = ({
  isSameLine,
  isShop,
  member_id,
  widgetName,
  isPostView,
}) => {
  const { isMobile, translations, isDesktop, locale } = useTheme();
  const { isLoggedInSso, loggedInToken, userInfo, showShimmer } =
    useSsoContext();

  const renderWidgetTitle = () => {
    return (
      <p
        {...classNames("bold font-20 mb-16", (isShop || isSameLine) && "pb-8")}
      >
        {translations.getListingWidgetForShop.title}
      </p>
    );
  };

  // Function to render widget title specifically for shop "in filter sidebar"
  const renderWidgetTitleIsShop = () => {
    return (
      <p {...classNames("bold font-20 mb-8")}>
        {translations.getListingWidgetForShop.title}
      </p>
    );
  };

  return (
    <section
      id="getMoreListing"
      {...classNames(
        "border p-16 radius-8 whiteBg",
        isMobile && "mb-32 p-8",
        isDesktop && !isSameLine && "mb-32",
        isDesktop && isSameLine && "width-50"
      )}
    >
      {isMobile && renderWidgetTitle()}
      <div
        {...classNames(
          "flex flexSpaceBetween ",
          isDesktop && isSameLine && "gap-20"
        )}
      >
        <div
            {...classNames(
                "flex flexDirectionColumn",
                isDesktop && isSameLine && !isPostView && locale === "ar"
                    ? "pb-16"
                    : "mb-16 pb-8"
            )}
        >
          {isDesktop && !isShop && renderWidgetTitle()}
          {isDesktop && isShop && renderWidgetTitleIsShop()}

          {isDesktop && isShop && (
            <div
              {...classNames(
                "flex width-100 mb-16 p-16 m-auto",
                isMobile && "mt-8",
                isDesktop && isSameLine && "pt-32"
              )}
            >
              <Image
                src="/images/entryPoints/getNewListing.webp"
                imageType="png"
                width={isDesktop ? "216" : "145"}
                height={isDesktop ? "106" : "70"}
                alt="Get New Listing Image"
                className="width-auto height-auto"
                loading="lazy"
              />
            </div>
          )}
            <div className="flex alignItems mb-16 gap-10 font-14">
              <IconCheckCircled />
              {translations.getListingWidgetForShop.item1}
            </div>
            <div className="flex alignItems mb-16 gap-10 font-14">
              <IconCheckCircled />
              {translations.getListingWidgetForShop.item2}
            </div>
            <div {...classNames("flex alignItems mb-16 gap-10 font-14")}>
              <IconCheckCircled />
              {translations.getListingWidgetForShop.item3}
            </div>
          {isDesktop && !isSameLine && (
            <button
              {...classNames(
                "blueBtn p-16 flex justifyContent alignItems gap-10 mt-auto"
              )}
              onClick={() => {
                gtmOpenShopBtnWidgetSeller();
                isLoggedInSso
                  ? loggedInToken().then(
                      () => (window.location.href = linkToOpenShop())
                    )
                  : loggedInToken(
                      () => (window.location.href = linkToOpenShop())
                    ).then();
                upgradeAccountClick({
                  currentWidgetName: widgetName
                    ? widgetName
                    : EnumWidgets.UPGRADE_ACCOUNT_CARD,
                  member_id,
                });
              }}
            >
              {translations.getListingWidgetForShop.getMoreListings}
            </button>
          )}
        </div>
        {!isShop && (
          <div
            {...classNames(
              isDesktop && !isSameLine && "width-33 mt-32",
              isMobile && "mt-8 width-50",
              isDesktop && isSameLine && "width-33 pt-32 mt-8"
            )}
          >
            <Image
              src="/images/entryPoints/getNewListing.webp"
              imageType="png"
              width={isDesktop ? "216" : "145"}
              height={isDesktop ? "106" : "70"}
              alt="Get New Listing Image"
              className="width-auto height-auto"
              loading="lazy"
            />
          </div>
        )}
      </div>

      {(isMobile || (isDesktop && isSameLine)) && (
        <button
          {...classNames(
            "blueBtn p-16 flex justifyContent alignItems width-100 gap-10 mt-auto"
          )}
          onClick={() => {
            gtmOpenShopBtnWidgetSeller();
            isLoggedInSso
              ? loggedInToken().then(
                  () => (window.location.href = linkToOpenShop())
                )
              : loggedInToken(
                  () => (window.location.href = linkToOpenShop())
                ).then();
            upgradeAccountClick({
              currentWidgetName: widgetName
                ? widgetName
                : EnumWidgets.UPGRADE_ACCOUNT_CARD,
              member_id,
            });
          }}
        >
          {translations.getListingWidgetForShop.getMoreListings}
        </button>
      )}
    </section>
  );
};

export default WidgetGetMoreListing;
